export default "__VITE_ASSET__CX55caho__"